import React from 'react'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import CalendarAddOnIcon from 'components/material-symbol/icons/CalendarAddOn'
import EventBusyIcon from 'components/material-symbol/icons/EventBusy'

const useStyles = makeStyles(() => ({
  menuIcon: {
    minWidth: 36,
    color: 'rgba(0, 0, 0, 0.54)',
  },
}))

/**
 * Shared Open / Blocked Time entries for the header Add Time menu and the
 * calendar cell context menu (icons + primary/secondary, not color swatches).
 */
const AddTimeMenuItems = ({ onSelectOpen, onSelectBlocked }) => {
  const classes = useStyles()

  return (
    <>
      <MenuItem onClick={onSelectOpen}>
        <ListItemIcon className={classes.menuIcon}>
          <CalendarAddOnIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Add Open Time"
          secondary="Bookable — one-time hours"
        />
      </MenuItem>
      <MenuItem onClick={onSelectBlocked}>
        <ListItemIcon className={classes.menuIcon}>
          <EventBusyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Add Blocked Time"
          secondary="Not bookable — vacation, time off"
        />
      </MenuItem>
    </>
  )
}

export default AddTimeMenuItems
